import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../layoutcontainers/DashboardLayout';
import MaterialDataGrid from '../../components/MaterialDataGrid';
import MaterialTypography from '../../components/MaterialTypography';
import { Card, Stack, CardHeader } from '@mui/material';
import MaterialButton from '../../components/MaterialButton';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import BASEURL from '../Utils/Baseurl';
import { useUserDetails } from '../../context/auth';

const Department = () => {
    const navigate = useNavigate();
    const {AccessData} = useUserDetails()

    const [pageState, setPageState] = useState({
        loading: false,
        error: false,
        message: "",
        state: 'init'
    });

    const [departmentList, setDepartmentList] = useState([]);

    useEffect(() => {
        onDepartmentSubmit();
    }, []);

    const departmentListTable = {
        columns: [
            {
                field: "departmentCode",
                headerName: "Department Code",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable:true,
            },
            {
                field: "departmentName",
                headerName: "Department Name",
                flex: 2,
                editable: false,
                disableColumnMenu: true,
                sortable:true,
            },
        ],
    };

    const handleNewDepartment = () => {
        navigate('/department/add-department');
    };

    const onDepartmentListClick = (e) => {
        console.log("jshdjssd:",e);
        
        console.log('onDepartmentListClick:', e?.id, e);
        if (e?.id) {
            navigate(`/department/department-details?id=${e?.id}`);
        }
    };

    const onDepartmentSubmit = async () => {
        const query = `query {
            allDepartment {
                id
                departmentName
                departmentCode
            }
        }`;

        try {
            setPageState({ ...pageState, loading: true });

            const response = await axios.post(BASEURL, {
                query: query
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            // Extract department data from the response
            const departmentList = response.data.data.allDepartment;
            console.log('departmentList:',departmentList);
            
            setDepartmentList(departmentList);
            setPageState({ ...pageState, loading: false, state: 'success' });

            console.log('Response:', departmentList);
        } catch (error) {
            console.error('ResponseError:', error);
            setPageState({ ...pageState, loading: false, error: true, message: error.message });
        }
    };

    return (
        <DashboardLayout>
            <Card >
                <CardHeader title={(
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Stack direction="column" spacing={0}>
                            <MaterialTypography variant="h5" fontWeight="medium">
                                Department list
                            </MaterialTypography>
                            {/* <MaterialTypography variant="caption" color="text" >
                                List of departments that you can get details of department.
                            </MaterialTypography> */}
                        </Stack>
            {AccessData && Array.isArray(AccessData) && AccessData.some(item => item.component === 'AddDepartment' && item.can_access)&& (

                        <MaterialButton
                            variant="gradient"
                            color="dark"
                            size="small"
                            startIcon={<AddIcon />}
                            onClick={() => handleNewDepartment()}
                        >
                            Department
                        </MaterialButton>
                          )}
                    </Stack>
                )} />
                <MaterialDataGrid
                 customHeight={500}
                    rows={departmentList}
                    columns={departmentListTable.columns}
                    checkboxSelection={false}
                    isSelectable={false}
                    onRowClick={onDepartmentListClick}
                    loading={pageState.loading}
                    localeText={{
                        noRowsLabel: (
                            <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                                <MaterialTypography variant="body2" fontWeight="medium" color="text">
                                    No department found
                                </MaterialTypography>
                                <MaterialTypography variant="caption" color="text">
                                    You have not yet added any department details. Click on the "Add Department" button to start adding department details.
                                </MaterialTypography>
                            </Stack>
                        )
                    }}
                />
            </Card>
            
        </DashboardLayout>
    );
};

export default Department;
